import React from 'react';
import styles from './ComingSoon.module.css';
import { Link } from 'react-router-dom';
import { FiTool, FiClock, FiAlertCircle, FiCode, FiSettings } from 'react-icons/fi';

const ComingSoon = ({ 
  title = "Feature Coming Soon", 
  message = "We're working hard to bring you this amazing feature. Stay tuned for updates!",
  estimatedTime = "Soon",
  showConstruction = true,
  icon = "tool",
  backgroundColor = "default"
}) => {
  const getIcon = () => {
    switch (icon) {
      case 'clock':
        return <FiClock className={styles.icon} />;
      case 'alert':
        return <FiAlertCircle className={styles.icon} />;
      case 'code':
        return <FiCode className={styles.icon} />;
      case 'settings':
        return <FiSettings className={styles.icon} />;
      case 'tool':
      default:
        return <FiTool className={styles.icon} />;
    }
  };

  const getBackgroundClass = () => {
    switch (backgroundColor) {
      case 'primary':
        return styles.primaryBg;
      case 'secondary':
        return styles.secondaryBg;
      case 'gradient':
        return styles.gradientBg;
      case 'default':
      default:
        return styles.defaultBg;
    }
  };

  return (
    <div className={`${styles.container} ${getBackgroundClass()}`}>
      <div className={styles.content}>
        {/* Animated Construction Illustration */}
        {showConstruction && (
          <div className={styles.illustration}>
            <div className={styles.constructionCrane}>
              <div className={styles.craneBase}></div>
              <div className={styles.craneTower}></div>
              <div className={styles.craneArm}></div>
              <div className={styles.craneHook}></div>
              <div className={styles.craneWeight}></div>
            </div>
            
            <div className={styles.constructionElements}>
              <div className={styles.brick}></div>
              <div className={styles.brick}></div>
              <div className={styles.brick}></div>
              <div className={styles.toolbox}></div>
              <div className={styles.blueprint}></div>
            </div>
            
            <div className={styles.workers}>
              <div className={styles.worker}></div>
              <div className={styles.worker}></div>
            </div>
          </div>
        )}

        {/* Content Section */}
        <div className={styles.textContent}>
          <div className={styles.iconContainer}>
            {getIcon()}
          </div>
          
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.message}>{message}</p>
          
          {/* Progress Indicator */}
          <div className={styles.progressSection}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill}></div>
            </div>
            <div className={styles.progressText}>
              <span>Development in progress</span>
              <span className={styles.estimatedTime}>{estimatedTime}</span>
            </div>
          </div>

          {/* Feature Highlights */}
          <div className={styles.featureHighlights}>
            <div className={styles.featureItem}>
              <div className={styles.featureDot}></div>
              <span>Innovative Design</span>
            </div>
            <div className={styles.featureItem}>
              <div className={styles.featureDot}></div>
              <span>Enhanced Performance</span>
            </div>
            <div className={styles.featureItem}>
              <div className={styles.featureDot}></div>
              <span>User-Friendly Interface</span>
            </div>
          </div>

          {/* Call to Action */}
          <div className={styles.ctaSection}>
            {/* <button className={styles.notifyButton}>
              Notify Me When Ready
            </button> */}
            <Link to='/' className='links'>
            <button className={styles.backButton}>
              Go Back
            </button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Floating Elements */}
      <div className={styles.floatingTools}>
        <div className={styles.floatingTool}></div>
        <div className={styles.floatingTool}></div>
        <div className={styles.floatingTool}></div>
      </div>
    </div>
  );
};

export default ComingSoon;